import React from 'react';
import tinycolor from 'tinycolor2';
import { color as colorStyles } from 'styled-system';
import { styled } from '@staffino/primitive-controls';

const StyledLabel = styled.label<{
  opacity?: number;
  backgroundColor?: string;
  hoverBackgroundColor?: string;
}>(
  (props) => ({
    cursor: 'pointer',
    height: '3.125rem',
    lineHeight: '1.25rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    borderRadius: '4px',
    color: 'white',
    fontWeight: 'bold',
    width: '50%',
    opacity: props.opacity ?? 0.5,
    margin: '0 0.5rem',
    'input:checked + &': {
      opacity: 1,
    },
    backgroundColor: props.backgroundColor,
    'input:hover + &': {
      boxShadow: `0rem 7px 15px 0rem ${tinycolor(props.hoverBackgroundColor)
        .setAlpha(0.3)
        .toRgbString()}`,
      backgroundColor: props.hoverBackgroundColor,
      backgroundImage: 'linear-gradient(0, rgba(0,0,0,0.2), rgba(0,0,0,0.2))',
    },
  }),
  colorStyles,
);

const HiddenRadio = styled.input({
  position: 'absolute',
  width: 0,
  height: 0,
  opacity: 0,
});

export default function SentimentButton({
  score,
  color,
  hoverColor,
  opacity,
  label,
  name,
  innerRef,
  onChange,
}) {
  return (
    <>
      <HiddenRadio
        ref={innerRef}
        type="radio"
        name={name}
        defaultValue={score}
        id={`${name}.${score}`}
        onChange={() => onChange?.(score)}
      />
      <StyledLabel
        htmlFor={`${name}.${score}`}
        backgroundColor={color}
        hoverBackgroundColor={hoverColor}
        opacity={opacity}
      >
        {label}
      </StyledLabel>
    </>
  );
}
